import { TLogin } from "@/schemas/auth";
import { api } from "./axios-config";

const ENDPOINTS = {
  LOGIN: "/user/login",
  EDIT_PASSWORD: "/user/password/edit",
  RESET_PASSWORD: "/user/password/reset",
  REQUEST_PASSWORD_RESET: "/user/password/reset/request",
};

export interface LoginResponse {
  statusCode: number;
  message: string;
  data: {
    roleType: string;
    userId: string;
    accessToken: string;
    user?: {
      id: string;
      email: string;
      name: string;
      role: string;
    };
  };
}

export interface EditPasswordRequest {
  userId: string;
  currentPassword: string;
  newPassword: string;
}

export interface ResetPasswordRequest {
  email: string;
  resetToken: string;
  newPassword: string;
}

export interface RequestPasswordResetRequest {
  email: string;
}

export const authServices = {
  queries: {
    // get calls
  },
  mutations: {
    login: (data: TLogin): Promise<LoginResponse> => api.post(ENDPOINTS.LOGIN, data),
    editPassword: (data: EditPasswordRequest) => api.put(ENDPOINTS.EDIT_PASSWORD, data),
    resetPassword: (data: ResetPasswordRequest) => api.post(ENDPOINTS.RESET_PASSWORD, data),
    requestPasswordReset: (data: RequestPasswordResetRequest) => api.post(ENDPOINTS.REQUEST_PASSWORD_RESET, data),
  },
};
